module.exports = __webpack_public_path__ + "static/media/sms.6285f40a.png";